import GRID_CAPACITY_CONFIG from './gridcapacity/GRID_CAPACITY_CONFIG'
import SIRAO_CONFIG from './sirao/SIRAO_CONFIG'

const APP = {
  GRID_CAPACITY: 'grid-capacity',
  SIRAO: 'sirao',
}
const CONFIG = {
  [APP.GRID_CAPACITY]: GRID_CAPACITY_CONFIG,
  [APP.SIRAO]: SIRAO_CONFIG,
}

const origin = window.location.origin
const currentApp =
  origin.match(/grid-capacity\.com/) || GRID_CAPACITY_CONFIG.appUrl.match(origin) ? APP.GRID_CAPACITY : APP.SIRAO
const currentConfig = CONFIG[currentApp]

// Import the corresponding stylesheet
switch (currentApp) {
  case APP.GRID_CAPACITY:
    import('./gridcapacity/gridcapacity.css')
    break
  case APP.SIRAO:
    import('./sirao/sirao.css')
    break
  default:
}

export default currentConfig
